// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610080335/js/" + chunkId + "." + {"44":"129e1e61","225":"64b5300e","481":"ac14ee3a","486":"37a0267b","770":"7cd18815"}[chunkId] + ".0.8205908315335225.chunk.js";
};